// extracted by mini-css-extract-plugin
export default {"container":"CardContentComponent_container__OG3UZ","count":"CardContentComponent_count__wBcKJ"};